import { render, staticRenderFns } from "./performance-scoring.vue?vue&type=template&id=0b5a5058"
import script from "./performance-scoring.vue?vue&type=script&lang=js"
export * from "./performance-scoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports